import { h } from 'preact'; /** @jsx h */

import './StickyCTA.scss';

const StickyCTA = ({
    title = 'Bli støttemedlem',
    text = 'Støtt Stiftelsen Norsk Luftambulanse med et engangsbeløp eller bli fast støttemedlem. Du kan også gi en gave i gave.',
    buttonText = 'Støtt oss her',
    link = '/gave/',
    orientation = 'right',
    buttonCaption = '',
    icon = false
}) => {
    return (
        <div className={`cta-wrapper cta-wrapper-${orientation}`}>
            <div className="sticky-cta">
                <div className={`sticky-cta-content ${buttonCaption === '' && 'no-btn-caption'}`}>
                    <h3 className="sticky-cta-title">{title}</h3>
                    <div className="sticky-cta-line top" />
                    <p className="sticky-cta-text">{text}</p>
                    <div className="sticky-cta-line bottom" />
                    <div className="sticky-cta-btn">
                        <a className={`cta-btn ${icon && 'with-icon'}`} href={link}>
                            <span>{buttonText}</span>
                            {icon && (
                                <span className="material-symbols-outlined">arrow_forward</span>
                            )}
                        </a>
                    </div>
                    {buttonCaption !== '' && (
                        <span className="sticky-cta-caption">{buttonCaption}</span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default StickyCTA;
